var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Default',[_c('ErrorPage',{attrs:{"code":404}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }